import { IconButton } from '@mui/material';
import { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { UseTableCellProps } from 'react-table';
import DeleteIcon from '@mui/icons-material/Delete';
import { IAdditionalQuoteDocumentationItem, IQuoteDocumentation } from 'shared/types';
import { useQuoteState } from 'shared/contexts';

export function QuoteFileDeleteColumn({ value }: UseTableCellProps<IAdditionalQuoteDocumentationItem>) {
  const { setValue } = useFormContext();
  const { editMode } = useQuoteState();
  const currentQuoteFiles = useWatch({ name: 'quoteDocumentation' }) as IQuoteDocumentation[];
  const currentQuoteFilesToDelete = useWatch({ name: 'quoteFilesToDelete' }) as IQuoteDocumentation[];

  const handleDelete = useCallback(
    (id: string) => {
      const fileToDelete = currentQuoteFiles.find(q => q.id === id);
      if (fileToDelete) {
        setValue('quoteFilesToDelete', [...currentQuoteFilesToDelete, fileToDelete], { shouldDirty: true });
        setValue(
          'quoteDocumentation',
          currentQuoteFiles.filter(q => q.id !== fileToDelete.id)
        );
      }
    },
    [currentQuoteFiles, currentQuoteFilesToDelete, setValue]
  );

  if (!editMode) return null;

  return (
    <IconButton color='primary' aria-label='delete file' title='Delete File' onClick={() => handleDelete(value)}>
      <DeleteIcon />
    </IconButton>
  );
}
